module.exports = __webpack_public_path__ + "static/media/straightLegRaise.fc33039e.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/fppExercises/straightLegRaise.png
// module id = 2539
// module chunks = 0